export default __webpack_public_path__ + "static/media/dp-kubernetes.2becd9f0.png";